<p-progressSpinner
  fill="transparent"
  strokeWidth="8"
  [class.db-spinner-sm]="isSmallSize()"
  [class.db-spinner-md]="isMediumSize()"
/>
